import { GROUPS, type GroupId } from "./groups";

/**
 * Which group a section id lives in — pure data, no section modules imported,
 * so the ui slice can migrate saved state without pulling the whole inspector
 * (and its custom React components) into the store.
 */
export function groupOfSection(sectionId: string): GroupId | null {
  for (const g of GROUPS) if (g.sections.includes(sectionId)) return g.id;
  return null;
}
